'use client'

import AppContext from '@/types/context'
import { useConsentReady } from '@/hooks/useConsentReady'
import { useEffect } from 'react'
import { ga4EventTracking } from '@/libs/Tracking/Tracking.lib'

export default function GA4Tracking({ context }: { readonly context: AppContext }) {
  const consentReady = useConsentReady()

  useEffect(() => {
    if (consentReady && context.metadata) {
      ga4EventTracking(context.metadata)
    }
  }, [consentReady])

  return <></>
}
